<template>
  <div class="counter-delete">
    <div class="top">
      <Header ref="header" moduleTitle="预配舱单-上海">
        <template slot="searchBox">
          <CounterDeleteSearch @fnSearch="searchList" @refreshSearch="refreshSearch" @exportExcel="exportExcel" />
        </template>
      </Header>
    </div>
    <div class="counter-delete-content">
      <el-button type="primary" style="width:144px" @click="submitCounterDeleteVisible = true">
        <i class="iconfont icon-tijiaoguimianshandan"></i>
        提交柜面删单
      </el-button>
      <WTable :WTableOpts="WTableOpts">

        <template #houseBillNo="{ row }">
          <div class="flex">
            <div class="table-content">{{ row.houseBillNo }}</div>
            <div class="content-center" v-if="row.houseBillNo" @click="copy(row.houseBillNo)"><i class="iconfont icon-fuzhi"></i></div>
          </div>
        </template>

        <template #remark="{ row }">
          <span>{{ row.remark ? getRemark(row.remark) : '/'  }}</span>
        </template>

        <template #ackStatus="{ row }">
          <div class="flex">
            <div class="table-content max-200" :class="getAckStatus(row.counterDelete)" v-if="row.counterDelete">{{ row.counterDelete.show }}</div>
            <div v-else>/</div>
          </div>
        </template>

        <template #ackContent="{ row }">
          <div class="flex">
            <div class="table-content max-200" v-if="row.counterDelete">{{ (row.counterDelete.detail && row.counterDelete.detail.remark) ? row.counterDelete.detail.remark : '/' }}</div>
            <div v-else>/</div>
          </div>
        </template>

        <template #newOperator="{ row }">
          <span v-if="row.modifierUser && row.modifierUser.nickname">{{ row.modifierUser.nickname }}</span>
          <span v-else>{{ row.creatorUser ? row.creatorUser.nickname : '/' }}</span>
        </template>

        <template #operation="{ row }">
          <el-link type="primary" :underline="false" @click="handleClick(row)">查看</el-link>
        </template>
      </WTable>
      <div class="pagination" v-if="total > 0">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" />
      </div>
    </div>
    <!-- 提交柜面删单 -->
    <SubmitCounterDelete v-if="submitCounterDeleteVisible" :visible="submitCounterDeleteVisible" @successDelete="successDelete" @closeDialog="closeDialog" />
    <!-- 柜面删单查看 -->
    <SubmitCounterDeleteCheck v-if="submitCounterDeleteCheckVisible" :visible="submitCounterDeleteCheckVisible" :detailData="detailData" @closeDialog="closeDialog" />
  </div>
</template>

<script>
import { drafts } from "@/api/index";
import download from "downloadjs"

import Header from "@/components/cps2/Header"
import CounterDeleteSearch from "./search/CounterDeleteSearch"
import SubmitCounterDelete from '@/views/new_cps/counterDelete/SubmitCounterDelete'
import SubmitCounterDeleteCheck from '@/views/new_cps/counterDelete/SubmitCounterDeleteCheck'
import { httpAgent } from "@/api/ajax";

export default {
  name: "CounterDelete",
  components: { 
    Header,
    CounterDeleteSearch,
    SubmitCounterDelete,
    SubmitCounterDeleteCheck
  },
  data(){
    return {
      total: 0, // 总数 
      pageNum: 1, // 页码 
      pageSize: 10, // 条数

      WTableOpts: {
        data: [],
        tableAttrs: { border: false },
        tableColAttrs: [
          { prop: '', label: '分提单号', slotName: 'houseBillNo', width: '200px' },
          { prop: '', label: '备注', slotName: 'remark', width: '400px' },
          { prop: 'payAmount', label: '删单费', width: '100px'},
          { prop: '', label: '状态', slotName: 'ackStatus', width: '120px' },
          { prop: '', label: '处理结果', slotName: 'ackContent', width: '300px' },
          { prop: '', label: '提交人', slotName: 'newOperator', width: '150px'},

          { prop: 'gmtModified', label: '操作时间', 'min-width': '200px' },
          { prop: '', label: '操作', width: '80px', slotName: 'operation',fixed:"right"  }
        ]
      },
      submitCounterDeleteVisible: false,
      submitCounterDeleteCheckVisible: false,
      detailData: {}
    }
  },
  created(){
    this.getList()
  },
  methods:{
    // 获取列表
    getList(){
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ...this.searchData,
        type: 'COUNTER_DELETE',
        ackStatus: (this.searchData && this.searchData.ackStatus) ? this.searchData.ackStatus.toString() : '',
      }
      httpAgent({
        url: `/agent/ccam/orders`,
        method: "get",
        data:params
      }).then((res) => {
        this.WTableOpts.data = res.records
        this.total = res.total

        res.records.forEach(item => {
          if(item.ccamDispositionHistorys && item.ccamDispositionHistorys.length > 0){
            item.ccamDispositionHistorys.forEach(key => {
              if(key.type == 'ACK_STATUS'){
                item.ackStatus = key
              }
              if(key.type == 'DELETE_STATUS'){
                item.deleteStatus = key
              }
              if(key.type == 'LOAD_STATUS'){
                item.loadStatus = key
              }
              if(key.type == 'CUSTOMS_STATUS'){
                item.customsStatus = key
              }
              if(key.type == 'COUNTER_DELETE_STATUS'){
                item.counterDelete = key
              }
              
            })
          }
        })
      })
    },
    getRemark(row){
      return row ? decodeURIComponent(atob(row)) : ''
    },
    // 复制
    copy(e){
      this.$copyText(e)
			this.$message({
				type: 'success',
				message: '复制成功!'
			})
    },
    // 提交成功
    successDelete(){
      this.$refs.header.getAccount()
      this.getList()
      this.closeDialog()
    },
    // 导出
    exportExcel(query){
      if(!query.gmtModifiedBegin && !query.gmtModifiedEnd){
        this.$message({
          message: '请选择时间',
          type: 'error'
        })
        return
      }
      let param = {
        ...query,
        ackStatus: (query && query.ackStatus) ? query.ackStatus.toString() : '',
      }
      httpAgent({
        url: `/agent/ccam/export`,
        method: "get",
        data: param,
        responseType: "blob"
      }).then((res) => {
        download(res, `${'CPS导出数据'}.xlsx`)
      })
    },
    // 获取预配回执颜色 
    getAckStatus(row){
      if(row.dispositionCode == 'CCAM_COUNTER_DELETE_PENDING'){
        return 'w-yellow-1'
      }
      if(row.dispositionCode == 'CCAM_COUNTER_DELETE_WAITING'){
        return 'w-yellow-1'
      }
      if(row.dispositionCode == 'CCAM_COUNTER_DELETE_SUCCESS'){
        return 'w-green-1'
      }
      if(row.dispositionCode == 'CCAM_COUNTER_DELETE_FAILURE'){
        return 'w-red-1'
      }
    },
    // 重置
    refreshSearch(){
      this.searchData = {}
    },
    // 点击查询
    searchList(query){
      this.searchData = query
      this.pageNum = 1
      this.pageSize = 10
      this.getList()
    },
    // 切换条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val
      this.getList()
    },
    // 切换页码
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val
      this.getList()
    },

    // 查看详情
    handleClick({ id }){
      drafts.counterDetail(id).then(res => {
        this.detailData = res
        this.submitCounterDeleteCheckVisible = true
      })
    },
    closeDialog(){
      this.submitCounterDeleteVisible = false;
      this.submitCounterDeleteCheckVisible = false;
    }
  }
};
</script>
<style scoped lang="less">
.counter-delete {
  font-size: 14px;
  color: #333333;
  display: flex;
  flex-direction: column;
  height: 100%;
  .counter-delete-content {
    position: relative;
    background: #ffffff;
    border-radius: 4px;
    padding: 24px;
    height: 100%;
  }
  .icon-fuzhi {
    color: #1170eb;
    font-size: 12px;
    cursor: pointer;
    margin-left: 10px !important;
  }
  .icon-tijiaoguimianshandan {
    font-size: 12px;
    margin-right: 4px !important;
  }
  .el-button--primary {
    margin-bottom: 24px;
  }
}
</style>
